import { CustomSelect, CustomSelectProps } from '@lfg/ui/components';
import { Box, Typography } from '@mui/material';

import { colors } from 'src/global/styles/colors';

export interface AdminSelectProps extends CustomSelectProps {
  isError?: boolean;
  errorMsg?: string;
}

export default function AdminSelect({ isError, errorMsg, disabled, options, sx, ...rest }: AdminSelectProps) {
  return (
    <Box>
      <CustomSelect
        focusedBorderColor='white'
        borderColor={isError ? colors.error : '#FFFFFF26'}
        disabled={disabled || !options.length}
        sx={{
          '& .MuiSelect-select.Mui-disabled': {
            WebkitTextFillColor: 'white',
          },
          ...sx,
        }}
        options={options}
        {...rest}
      />
      {isError ? (
        <Typography paddingTop={1} color={colors.error} fontSize={'14px'}>
          {errorMsg}
        </Typography>
      ) : null}
    </Box>
  );
}
